import React from 'react';

import { CenteredLayoutComponent } from 'design/centeredLayout/centeredLayoutComponents';
import { SpinnerExtraLarge } from 'design/spinnerExtraLarge/spinnerExtraLargeComponents';
import { FinishScreenLayout } from 'design/finishScreenLayout/finishScreenLayout';
import { TextComponent } from 'design/text/textComponents';
import { useIntlDictionary } from 'hooks/useIntlDictionary';

export const ProdStackLoadingFallback = () => {
  const { prodStackManager: ownDictionary } = useIntlDictionary();

  return (
    <CenteredLayoutComponent>
      <FinishScreenLayout
        top={<SpinnerExtraLarge />}
        middle={
          <TextComponent>
            {ownDictionary.finishCompleteFallbackDescriptionText}
          </TextComponent>
        }
      />
    </CenteredLayoutComponent>
  );
};
